import React from 'react';
import { connect } from 'react-redux';
import { Form, Select } from 'antd';
const { Option } = Select;

const Drivers = ({ form, drivers }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Водитель:">
      {getFieldDecorator('drivers')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите водителя"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {drivers &&
            drivers.map(driver => (
              <Option key={driver.id} label={driver.id}>
                {driver.userName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default connect(state => ({
  drivers: state.Executorship.Orders.orders.allDrivers,
}))(Drivers);
